
export const GET_EMPLOYEE_PROFILE_SUCCESS = 'GET_EMPLOYEE_PROFILE_SUCCESS';
export const GET_EMPLOYEE_PROFILE_REQUEST = 'GET_EMPLOYEE_PROFILE_REQUEST';
export const GET_EMPLOYEE_PROFILE_FAILURE = 'GET_EMPLOYEE_PROFILE_FAILURE';

export const UPDATE_EMPLOYEE_PROFILE_SUCCESS = 'UPDATE_EMPLOYEE_PROFILE_SUCCESS';
export const UPDATE_EMPLOYEE_PROFILE_REQUEST = 'UPDATE_EMPLOYEE_PROFILE_REQUEST';
export const UPDATE_EMPLOYEE_PROFILE_FAILURE = 'UPDATE_EMPLOYEE_PROFILE_FAILURE';